import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField, ArrayItemCard, RemoveButton } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const AboutAdditionalInfoSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const additionalInfoCardsPath = useFieldPath('sections.aboutAdditionalInfo.additionalInfoCards')

  const additionalInfoCards = get(values, additionalInfoCardsPath, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <h4>Cards de Informações Adicionais</h4>
      <FieldArray name={additionalInfoCardsPath}>
        {(arrayHelpers) => (
          <>
            {additionalInfoCards.map((card, index) => (
              <ArrayItemCard key={index}>
                <RemoveButton>
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => arrayHelpers.remove(index)}
                  />
                </RemoveButton>
                <FormField>
                  <label>Número (opcional)</label>
                  <Input
                    name={`${additionalInfoCardsPath}.${index}.number`}
                    value={card.number}
                    onChange={handleChange}
                    placeholder="Ex: 01"
                  />
                </FormField>
                <FormField>
                  <label>Título</label>
                  <Input
                    name={`${additionalInfoCardsPath}.${index}.title`}
                    value={card.title}
                    onChange={handleChange}
                    placeholder="Ex: Certificação reconhecida"
                  />
                </FormField>
                <FormField>
                  <label>Descrição</label>
                  <TextArea
                    name={`${additionalInfoCardsPath}.${index}.description`}
                    value={card.description}
                    onChange={handleChange}
                    rows={2}
                    placeholder="Descrição do card"
                  />
                </FormField>
              </ArrayItemCard>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push({ number: '', title: '', description: '' })}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Card
            </Button>
          </>
        )}
      </FieldArray>
    </Card>
  )
}
